// extracted by mini-css-extract-plugin
module.exports = {"title":"CameraViewTitle_title__SJVBJ"};